import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-text-input',
  templateUrl: './fc-text-input.component.html',
  styleUrls: ['./fc-text-input.component.scss']
})
export class FcSearchInputComponent  {
  @Input()
  public control: FormControl;

  @Input()
  public label: string;

  @Input()
  public hint: string;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public isLoading = false;

  constructor(fuseTranslationLoaderService: FuseTranslationLoaderService) {
    fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

}
